import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { postsService, WordPressPost } from '../../api/api.service';
import PostCard from '../postcard/PostCard';
import './HomeBlogSection.css';

const HomeBlogSection: React.FC = () => {
    const [posts, setPosts] = useState<WordPressPost[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                setLoading(true);
                // Fetch only 3 posts for the home page
                const data = await postsService.getPosts({ per_page: 3 });
                setPosts(data);
            } catch (err) {
                setError("Blogs Unavailable, Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    // Helper to extract clean data for PostCard
    const transformPostData = (post: WordPressPost) => {
        const featureMedia = post._embedded?.["wp:featuredmedia"]?.[0];
        const authorData = post._embedded?.author?.[0];

        // Strip HTML from excerpt
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = post.excerpt.rendered;
        const cleanExcerpt = tempDiv.textContent || tempDiv.innerText || "";

        return {
            id: post.id,
            image: postsService.getMediaBaseUrl(featureMedia),
            title: post.title.rendered,
            author: authorData?.name || "Unknown Author",
            authorImage: authorData?.avatar_urls?.["96"] || "",
            date: postsService.formatDate(post.date),
            excerpt: cleanExcerpt,
        };
    };

    return (
        <section className="home-blog-section">
            <div className="home-blog-container">
                {/* Header Section */}
                <div className="home-blog-header">
                    <div className="header-left">
                        <span className="subtitle">INSIGHTS <span className="square-dot">■</span></span>
                        <h2>Legal news & <span className="cursive-text">blogs</span></h2>
                    </div>
                    <div className="header-right">
                        <Link className="consultation-btn" to="/blog" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            <b>View All</b>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="btn-icon">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    </div>
                </div>

                {/* Content Section */}
                <div className="home-blog-grid">
                    {loading ? (
                        <div className="loading-state">Loading latest news...</div>
                    ) : error ? (
                        <div className="error-message">{error}</div>
                    ) : (
                        posts.map((post) => (
                            <div key={post.id} className="home-blog-card-wrapper">
                                <PostCard {...transformPostData(post)} showContent={true} />
                            </div>
                        ))
                    )}
                </div>
                {/* Far Right Sidebar */}
                <div className="sidebar-icon sidebar-icon-top" onClick={scrollToTop}>
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                    >
                        <path d="M12 19 L12 5 M5 12 L12 5 L19 12" />
                    </svg>
                </div>
            </div>
        </section>
    );
};

export default HomeBlogSection;
